import { Component } from "react";
import { Link } from "react-router-dom";

export class CategoryNavigator extends Component{
    render(){
        return<>
        <Link className="text-sm text-slate-600" to={this.props.baseUrl}>All</Link>
        {this.props.categories && this.props.categories.map((r,i)=>
        <Link className="text-sm text-slate-600" to={`${this.props.baseUrl}/${r.toLowerCase()}`} key={i}>{r}</Link>)}
        </>
    }
}